import React, { useEffect, useState } from 'react';
import './businessaccountmanagement.scss';
import { Tabs, Table, Avatar, Button, Tag, Space, Modal, Input, Row, Col } from 'antd';
import { PlusOutlined, EyeOutlined, ExclamationCircleOutlined, UploadOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import SimpleButton from '../../../components/buttons/simpleButton/SimpleButton';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../app/store';
import { acceptOrRejectRequest, deleteONUserRequest, fetchRequestLists, licenseApproveOrReject, editLicense, fetchONUserDetails } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { Skeleton, Card } from 'antd';
import { AccountDetailsModal } from './AccountDetailsModal/AccountDetailsModal';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../constants';
import { fetchNotesList } from '../../../features/users/usersSlice';
import { deleteBusinessAccountList, fetchBusinessAccountList, fetchDeletedBusinessAccountList, fetchViewNetworksList } from '../../../features/members/membersSlice';
import { fetchDeletedAccountsList } from '../../../features/accounts/accountsSlice';
import { LiaSearchSolid } from 'react-icons/lia';

interface UserData {
  key: string;
  name: string;
  email: string;
  status: string;
  avatar: string;
}

export const BusinessAccountLists = () => {

  const navigate = useNavigate()
  const { confirm } = Modal;
  const dispatch = useDispatch<appDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activeTab, setActiveTab] = useState<string>('businessusers');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [selectedRowIds, setSelectedRowIds] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [selectedUserNetworks, setSelectedUserNetworks] = useState<any>(null);
  const [searchquery, setSearchquery] = useState<string>("");
  
  const businessAccountList = useSelector((state: RootState) => state.members.fetchBusinessAccountList.fetchBusinessAccountListData);
  const {
    userDetailsData,
    isLoading:isUserDetailsLoading,
  } = useSelector((state: RootState) => state.requestLsts.fetchONUserDetails);


  const  fetchDeletedBusinessAccountListData= useSelector((state: RootState) => state.members.fetchDeletedBusinessAccountList.fetchDeletedBusinessAccountListData);


  const {
    isLoading: isLicenseActionLoading,
  } = useSelector((state: RootState) => state.requestLsts.licenseApproveOrReject);

  const {
    isLoading: isEditLicenseLoading,
  } = useSelector((state: RootState) => state.requestLsts.editLicense);

  const TABS = [
    { label: 'Business Account Users', key: 'businessusers', status: 'pending' },
     { label: 'Deleted Users', key: 'deleted', status: 'pending' },
  ];

  const dataToRender =
  activeTab === 'businessusers'
    ? businessAccountList
    : fetchDeletedBusinessAccountListData;

const handleTabChange = (key: string) => {
  setActiveTab(key);
  setPageNumber(1);

  const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

  if (key === 'businessusers') {
    dispatch(fetchBusinessAccountList(thunkArgs));
  } else if (key === 'deleted') {
    dispatch(fetchDeletedBusinessAccountList(thunkArgs));
  }
};


  console.log(businessAccountList,"businessAccountList")

    const resetTableSelection = () => {
    setSelectedRows([]);
  };

useEffect(() => {
  const currentTab = TABS.find(tab => tab.key === activeTab);
  const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

  if (currentTab?.key === 'businessusers') {
    dispatch(fetchBusinessAccountList(thunkArgs));
  } else if (currentTab?.key === 'deleted') {
    dispatch(fetchDeletedBusinessAccountList(thunkArgs)); // ✅ Correct list call
  }
}, [activeTab]);;

  const handleDeleteUser = () => {
    confirm({
      title: "Delete confirmation",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to delete?",
      centered: true,
      onOk() {
        const payload = {
         id:selectedRowIds?.[0]

        };
        dispatch(deleteBusinessAccountList(payload))
          .then((data) => {
            if (data.payload.isSuccess) {
              toast.success(data.payload.message);
              resetTableSelection();
              setTimeout(() => {
                // dispatch(fetchMembersList({ searchquery, pageNumber })); // refresh
                // dispatch(fetchNonMembersList({ searchquery, pageNumber })); // refresh
                dispatch(fetchBusinessAccountList({ searchquery, pageNumber })); // refresh
              }, 500)


            } else {
              toast.error(data.payload);
            }
          })
          .catch((error) => {
            console.error("Delete failed:", error);
          });
      },
      onCancel() { },
    });
  };

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };
  const handleSearch = () => {
    
    const params = {
      searchquery: searchquery ? searchquery : ""
    }
    
   if (activeTab === 'businessusers') {
    dispatch(fetchBusinessAccountList(params));
  } else if (activeTab === 'deleted') {
    dispatch(fetchDeletedBusinessAccountList(params));
  }
 
  }

  const handleViewDetails = async (user: any) => {
      // const params = { id: user?.id };  // <-- wrap in { id }
    await dispatch(fetchNotesList({ id: user?.id }));
    const response = await dispatch(fetchONUserDetails(user?.id))
   const networkResponse = await dispatch(
      fetchViewNetworksList({
        searchquery: user?.id, // ✅ Passing user.id correctly
        pageNumber: 1,         // ✅ Optional, can be dynamic
      })
    );
    if (networkResponse?.payload?.isSuccess) {
      setSelectedUserNetworks(networkResponse?.payload?.result?.result);
    }

    if(response?.payload?.isSuccess){
      setSelectedUser(user);
      setIsModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedUser(null);
  };

  const handleEditUserRequest = (user: any) => {
  console.log(user,"userrr")
  }

  const handleDeleteUserRequest = (user: any) => {
    confirm({
      title: 'Delete confirmation',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to delete?',
      centered: true,
      onOk() {
        // dispatch(deleteONUserRequest({id:user?.id}))
      },
      onCancel() { },
    });
  }

  const handleVerifyLicense = async (user: any, licenseIndex: number) => {
    try {
      const payload = {
        medical_licenses: user.medical_licenses.map((lic: any, idx: number) => ({
          license_number: lic.license_number,
          is_valid: idx === licenseIndex ? true : Boolean(lic.is_valid),
          validation_status: idx === licenseIndex ? "APPROVED" : (lic.validation_status || ""),
          ...(idx === licenseIndex && lic.comment ? { comment: lic.comment } : {}),
          country: {
            name: lic.country.name,
            country_name_code: lic.country.country_name_code
          },
          issuing_state: {
            name: lic.issuing_state.name,
            state_code: lic.issuing_state.state_code
          }
        }))
      };

      const response = await dispatch(licenseApproveOrReject({payload,userId:user?.id}));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license status
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} verified`);
      } else {
        toast.error(response?.payload || 'Failed to verify license');
      }
    } catch (e) {
      toast.error('Failed to verify license');
    }
  };

  const handleRejectLicense = async (user: any, licenseIndex: number, reason: string) => {
    try {
      const payload = {
        medical_licenses: user.medical_licenses.map((lic: any, idx: number) => ({
          license_number: lic.license_number,
          is_valid: idx === licenseIndex ? false : Boolean(lic.is_valid),
          validation_status: idx === licenseIndex ? "REJECTED" : (lic.validation_status || ""),
          ...(idx === licenseIndex ? { comment: reason } : (lic.comment ? { comment: lic.comment } : {})),
          country: {
            name: lic.country.name,
            country_name_code: lic.country.country_name_code
          },
          issuing_state: {
            name: lic.issuing_state.name,
            state_code: lic.issuing_state.state_code
          }
        }))
      };

      const response = await dispatch(licenseApproveOrReject({payload,userId:user?.id}));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license status
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} rejected`);
      } else {
        toast.error(response?.payload || 'Failed to reject license');
      }
    } catch (e) {
      toast.error('Failed to reject license');
    }
  };

  const handleEditLicense = (user: any, licenseIndex: number, updatedLicense: any) => {
    try {
      setSelectedUser((prev: any) => {
        if (!prev) return prev;
        const updated = { ...prev };
        if (updated.medical_licenses && updated.medical_licenses[licenseIndex]) {
          updated.medical_licenses = [...updated.medical_licenses];
          updated.medical_licenses[licenseIndex] = {
            ...updated.medical_licenses[licenseIndex],
            ...updatedLicense,
          };
        }
        return updated;
      });
      toast.success(`License #${licenseIndex + 1} updated`);
    } catch (e) {
      toast.error('Failed to update license');
    }
  };

  const handleSaveLicense = async (user: any, licenseIndex: number, updatedLicense: any) => {
    try {
      const payload = {
        payload:{
        medical_licenses: [updatedLicense]
      },
      userId:user?.id
    }

      const response = await dispatch(editLicense(payload));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} saved successfully`);
      } else {
        toast.error(response?.payload || 'Failed to save license');
      }
    } catch (e) {
      toast.error('Failed to save license');
    }
  };

  const handleRequestAccept = async (user: any,isApprove: boolean,Reason?:string) => {
    const approvePayload = {
      payload:{
        "approval_status": "APPROVED"
      },
      id:user?.id
    }
    const rejectPayload = {
      payload:{
        "approval_status": "REJECTED",
        "comment": Reason ?? ""
      },
      id:user?.id
    }
    const response = await dispatch(acceptOrRejectRequest(isApprove ? approvePayload : rejectPayload))
    console.log("test res response",response)
    if(response?.payload?.isSuccess){
      toast.success(response?.payload?.message)
      handleModalClose();
      // Refresh the current tab data
      const currentTab = TABS.find(tab => tab.key === activeTab);
      if (currentTab) {
        dispatch(fetchRequestLists({searchQuery: searchQuery, status: currentTab.status, page: pageNumber}))
      }
    }else{
      toast.error(response?.payload)
    }
  }




  const columns = [
    {
      title: 'User',
      key: 'display_name',
      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.name}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      render: (email: string) => (
        <span style={{ color: "var(--common-black-white)", fontSize: 13 }}>{email}</span>
      ),
    },
  
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button 
          type="primary" 
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },
  ];

 const rowSelection :any= {
  type: "radio",
  selectedRowKeys: selectedRowIds,

  onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: any[]) => {
    setSelectedRowIds(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  },

  onSelect: (record: any, selected: boolean) => {
    if (selected) {
      setSelectedRowIds([record.id]);   // only 1 selection
      setSelectedRows([record]);
    } else {
      setSelectedRowIds([]);
      setSelectedRows([]);
    }
  }
};



  const renderTableContent = () => {
    return (
      <div>
        <Table 
          columns={columns} 
          rowSelection={activeTab === "deleted" ? undefined : rowSelection}
          dataSource={dataToRender} 
          pagination={{
                position: ["bottomRight"],
                  pageSize: 10,
                  current: pageNumber,
                // pageSize: businessAccountList?.per_page,
                // current: pageNumber,
                onChange: (page) => handlePageChange(page),
                // total: totalCount,
                showSizeChanger: false,
                showQuickJumper: true,
                showTotal: (total, range) => (
                  <div className="pagniation-text">
                    {`${range[0]}-${range[1]} of ${total} items`}
                  </div>
                ),
              }
          }
          rowKey="id"
          size="small"
          style={{ fontSize: 13 }}
        />
      </div>
    );
  };

  const tabItems = TABS.map(tab => ({
    label: tab.label,
    key: tab.key,
    children:
    //  isLoading ? (
    //   <div style={{ padding: '20px' }}>
    //     <Skeleton active paragraph={{ rows: 8 }} />
    //   </div>
    // ) : (
      renderTableContent()
    // ),
  }));

  const handleAddUser = () =>{
    navigate("/superadmin/request-lists/add-user",{state:{
      isEditMode:false,
    }})
  }

  return (
    <div className="request-lists-container">

      
            {/* <Row className="button-container" gutter={[16, 16]} align="middle" justify="space-between"> */}
              {/* Left section: Search */}
              <Col xs={24} sm={24} md={12}>
                <Row gutter={8} align="middle">
                  <Col flex="auto">
                    <span className="search-bar">
                      <Input
                        placeholder="Search"
                        prefix={<LiaSearchSolid className="search-bar-icon" />}
                        onChange={(e) => setSearchquery(e.target.value)}
                      />
                    </span>
                  </Col>
                  <Col>
                    <SimpleButton
                      text="Search"
                      color="primary"
                      icon={<SearchOutlined />}
                      onClick={handleSearch}
                    />
                  </Col>
                </Row>
              </Col>
            {/* </Row> */}
      
      <Tabs
        items={tabItems}
        defaultActiveKey="approval"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="request-lists-tabs"
        tabBarExtraContent={
          <div className="register-user-btn-wrapper">
        {activeTab!=="deleted"? <SimpleButton  disabled={selectedRowIds?.length ===0}onClick={handleDeleteUser} text='Delete User' icon={<DeleteOutlined />} color="secondary" />:null }    
         
          </div>
        }
      />
      
      <AccountDetailsModal
        isVisible={isModalVisible&&userDetailsData}
        user={selectedUser}
        selectedUserNetworks={selectedUserNetworks}
        // user={businessAccountList}
        onClose={handleModalClose}
        onAccept={handleRequestAccept}
        onReject={handleRequestAccept}
        currentTab={activeTab}
        onEdit={handleEditUserRequest}
        onDelete={handleDeleteUserRequest}
        onVerifyLicense={handleVerifyLicense}
        onRejectLicense={handleRejectLicense}
        onEditLicense={handleEditLicense}
        onSaveLicense={handleSaveLicense}
        isLicenseActionLoading={isLicenseActionLoading}
        isEditLicenseLoading={isEditLicenseLoading}
      />
    </div>
  );
}
